import axios from "axios";

import router from "./router";
import Load from 'common/js/loading'

import { getToken, deleteToken } from "common/js/storage";

// 请求接口数目
let allResquest = 0
// axios 配置
axios.defaults.timeout = 1800000;

// http request 拦截器
axios.interceptors.request.use(
  config => {
    config.headers["Content-Type"] = "application/json";
    let token = getToken();
    if (token) {
      // 将token设置成请求头
      config.headers["Auth-Token"] = token;
    }
    allResquest = allResquest + 1
    Load.loading()
    return config;
  },
  err => {
    return Promise.reject(err);
  }
);

// http response 响应器
axios.interceptors.response.use(
  response => {
    allResquest = allResquest - 1
    if (allResquest === 0) {
      Load.hideLoading();
    }
    if (response.data.code === 1002) {
      router.replace({
        path: "/login"
      });
    }
    if (response.data.code === 1004) {
      deleteToken()
      let str = window.location.pathname.split('/')[1];
      if (str === 'customers') {
        router.replace({
          path: '/customers-login',
        })
      } else {
        router.replace({
          path: '/'
        })
      }
    }
    return response;
  },
  err => {
    allResquest = allResquest - 1
    Load.hideLoading();
    console.log(err);
    return Promise.reject(err);
  }
);

export default axios;
